import { REGIONS, JOB_GUIDES, PRACTICAL_GUIDES, CONDITIONS_GUIDES, type GuideSeason } from '@/lib/guides';

export function exploreGuidePath(guide: { slug: string; season: GuideSeason }): string {
  // Festival job guides are standalone pages under /festivals/<slug>, not
  // /guides/<slug>. Returning /guides/<slug> for them made the /guides/[slug]
  // catch-all permanentRedirect to itself (an infinite 308 loop) and emitted
  // those broken URLs into the sitemap. Route festival guides to their real
  // /festivals/<slug> pages.
  if (guide.season === "festival") return `/festivals/${guide.slug}`;
  return `/guides/${guide.slug}`;
}

const ALL_GUIDES = [
  ...REGIONS.flatMap((r) => r.guides),
  ...JOB_GUIDES,
  ...PRACTICAL_GUIDES,
  ...CONDITIONS_GUIDES,
];
const BY_SLUG = new Map(ALL_GUIDES.map((g) => [g.slug, g] as const));

export function exploreGuidePathBySlug(slug: string): string | null {
  const g = BY_SLUG.get(slug);
  return g ? exploreGuidePath(g) : null;
}
